// Question Types
// 1. MCQs | Multiple Choice | single
// 2. boolean | true/false | single
// 3. MAQs | Multiple Answers | multiple

import { Topic } from '.'

export const autoeficacia: Topic = {
  topic: 'Auto_Eficácia',
  level: 'Intermediate',
  totalQuestions: 10,
  totalScore: 95,
  totalTime: 600,
  questions: [
    {
      question: 'Eu acredito que posso enfrentar com sucesso os desafios da vida cotidiana.',
      choices: [
        { choice: "Discordo completamente", score: 0 },
        { choice: "Discordo", score: 1 },
        { choice: "Neutro", score: 2 },
        { choice: "Concordo", score: 3 },
        { choice: "Concordo completamente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Mesmo quando as coisas estão difíceis, tenho confiança na minha capacidade de encontrar uma solução',
      choices: [
        { choice: "Discordo completamente", score: 0 },
        { choice: "Discordo", score: 1 },
        { choice: "Neutro", score: 2 },
        { choice: "Concordo", score: 3 },
        { choice: "Concordo completamente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Acredito que posso atingir meus objetivos, não importa o quão difícil possa ser.',
      choices: [
        { choice: "Discordo completamente", score: 0 },
        { choice: "Discordo", score: 1 },
        { choice: "Neutro", score: 2 },
        { choice: "Concordo", score: 3 },
        { choice: "Concordo completamente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Tenho confiança na minha capacidade de superar obstáculos e dificuldades',
      choices: [
        { choice: "Discordo completamente", score: 0 },
        { choice: "Discordo", score: 1 },
        { choice: "Neutro", score: 2 },
        { choice: "Concordo", score: 3 },
        { choice: "Concordo completamente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Eu acredito que posso me adaptar a novas situações, mesmo que sejam desafiadoras.',
      choices: [
        { choice: "Discordo completamente", score: 0 },
        { choice: "Discordo", score: 1 },
        { choice: "Neutro", score: 2 },
        { choice: "Concordo", score: 3 },
        { choice: "Concordo completamente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Tenho confiança na minha capacidade de lidar com situações de estresse',
      choices: [
        { choice: "Discordo completamente", score: 0 },
        { choice: "Discordo", score: 1 },
        { choice: "Neutro", score: 2 },
        { choice: "Concordo", score: 3 },
        { choice: "Concordo completamente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Acredito que posso influenciar positivamente as coisas que acontecem em minha vida.o',
      choices: [
        { choice: "Discordo completamente", score: 0 },
        { choice: "Discordo", score: 1 },
        { choice: "Neutro", score: 2 },
        { choice: "Concordo", score: 3 },
        { choice: "Concordo completamente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Mesmo quando enfrento incertezas, acredito que posso tomar as decisões certas.',
      choices: [
        { choice: "Discordo completamente", score: 0 },
        { choice: "Discordo", score: 1 },
        { choice: "Neutro", score: 2 },
        { choice: "Concordo", score: 3 },
        { choice: "Concordo completamente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Tenho confiança na minha capacidade de alcançar sucesso em várias áreas da vida.',
      choices: [
        { choice: "Discordo completamente", score: 0 },
        { choice: "Discordo", score: 1 },
        { choice: "Neutro", score: 2 },
        { choice: "Concordo", score: 3 },
        { choice: "Concordo completamente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Eu acredito que posso lidar eficazmente com os desafios que o futuro possa trazer.',
      choices: [
        { choice: "Discordo completamente", score: 0 },
        { choice: "Discordo", score: 1 },
        { choice: "Neutro", score: 2 },
        { choice: "Concordo", score: 3 },
        { choice: "Concordo completamente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    

  ],
}
